import { Box, useMediaQuery, VStack } from '@chakra-ui/react';
import { Order, OrderWithDeliveryOrders } from '@diamond/shared/types';
import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';
import {
  bindPromoData,
  extractOrderPromoBannerData,
  extractOrderVoucherBannerData,
  OrderDetailDataWithDivider,
} from '@diamond/sol-buyer/utils';

import { MobileProductTable, ProductTable } from '../common';
import { OrderPromoBannerSummary } from './OrderPromoBannerSummary';
import { OrderVoucherBannerSummary } from './OrderVoucherBannerSummary';
import { RingkasanTagihan } from './RingkasanTagihan';
interface RincianProdukProps {
  order: Order;
  accessToken?: string;
  deliveryOrders?: OrderWithDeliveryOrders[];
}

export function RincianProduk({
  order,
  accessToken,
  deliveryOrders,
}: RincianProdukProps) {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  const isVoucherMenuEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_VOUCHERS_MENU,
    true
  );

  const productData: OrderDetailDataWithDivider = order.items
    ?.filter((item) => item.products.length !== 0)
    .map(({ division, ...rest }) => ({
      divider: division === 'fnb' ? 'fine food' : division,
      ...rest,
    }));

  const dataWithPromo = bindPromoData(productData);
  const isSubmitted = order.is_submitted;

  const promoBanners = extractOrderPromoBannerData(order.items);
  const orderProducts = order.items.flatMap((item) => item.products);
  const voucherBanners = extractOrderVoucherBannerData(
    order.vouchers?.applied_vouchers ?? [],
    orderProducts
  );
  const hasPromoOrVoucher =
    promoBanners.length > 0 || voucherBanners.length > 0;

  return (
    <Box
      flex="1"
      border={{ base: 'unset', md: '1px' }}
      borderColor={{ base: 'unset', md: 'rgba(217, 217, 217, 1)' }}
      shadow="none"
      px={{ base: 'unset', md: '0' }}
      py={{ base: 'unset', md: '8' }}
      scrollMarginTop={'10rem'}
      rounded="lg"
      id="rincian-produk"
    >
      {isMobile ? (
        <MobileProductTable
          data={dataWithPromo}
          isSubmitted={isSubmitted}
          order={order}
          accessToken={accessToken}
          deliveryOrders={deliveryOrders}
          extra={
            <VStack spacing="4" align="stretch">
              <OrderPromoBannerSummary order={order} />
              {isVoucherMenuEnabled && (
                <OrderVoucherBannerSummary order={order} />
              )}
              <RingkasanTagihan
                savedTotal={order.saved_total}
                originalSubtotal={order.original_total}
                finalSubtotal={order.total}
                originalTotal={order.payment?.total}
                hasPromoOrVoucher={hasPromoOrVoucher}
              />
            </VStack>
          }
        />
      ) : (
        <ProductTable
          data={dataWithPromo}
          isSubmitted={isSubmitted}
          deliveryOrders={deliveryOrders}
          extra={
            <Box mt="4">
              <OrderPromoBannerSummary order={order} />
              {isVoucherMenuEnabled && (
                <OrderVoucherBannerSummary order={order} />
              )}
              <RingkasanTagihan
                savedTotal={order.saved_total}
                originalSubtotal={order.original_total}
                finalSubtotal={order.total}
                originalTotal={order.payment?.total}
                hasPromoOrVoucher={hasPromoOrVoucher}
              />
            </Box>
          }
        />
      )}
    </Box>
  );
}

export default RincianProduk;
